const setResumeInterests = (interests) => ({
    type: 'SET_RESUME_INTERESTS',
    interests,
});

export default setResumeInterests;
